export function csrfTokenHeader() {
  return {"X-CSRF-Token": Rails.csrfToken()};
}

export function updateCsrfToken(csrfToken) {
  document.querySelector("meta[name=csrf-token]").setAttribute("content", csrfToken);
}
